import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function trackProduct(productCode: string): void {
  const url = occUrl(`/p/${productCode}/trackProduct`);
  occFetch(url, {
    method: "POST",
  }).catch(() => {
    // Intentionally ignored: recently-viewed tracking must never break the PDP.
  });
}
